const skills = [
  {
    category: "Languages",
    items: [
      "C++",
      "C#",
      "SQL",
      "PowerShell",
      "Batch",
      "Bash",
      "HTML",
      "CSS",
      "JavaScript",
    ],
  },
  {
    category: "Game Development",
    items: [
      "Unreal Engine 4",
      "Unreal Engine 5",
      "UMG",
      "Common UI",
      "Enhanced Input",
      "Unreal Engine Editor Tools",
    ],
  },
  {
    category: "Backend & Web",
    items: [
      "REST API",
      "WebAPI",
      "MVC Web Apps",
      "Node.js",
      "Express.js",
      "React",
    ],
  },
  {
    category: "Cloud & Services",
    items: ["Azure Functions", "Azure Service Bus"],
  },
  {
    category: "Version Control & DevOps",
    items: ["Git", "SVN", "Perforce", "Azure DevOps"],
  },
  {
    category: "Workflow",
    items: ["Jira", "Confluence", "Agile"],
  },
];

export default skills;
